import { useEffect, useState } from 'react';

import { MILLISECONDS_PER_SECOND } from 'constants/date';

import { formatElapsedTime } from './utils';

const useElapsedTime = startTime => {
  const [elapsedText, setElapsedText] = useState(() => formatElapsedTime(startTime));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setElapsedText(formatElapsedTime(startTime));
    }, MILLISECONDS_PER_SECOND);

    return () => clearInterval(intervalId);
  }, [startTime]);

  return elapsedText;
};

export default useElapsedTime;
